import _ from "lodash";

export default class LowResChecker {
    store;
    canvas;

    constructor(store) {
        this.store = store;
        this.canvas = store.canvas;

        this.mount();
    }

    mount() {
        let canvas = this.canvas;

        this.checkSize = this.checkSize.bind(this);
        canvas.on('object:scaling', this.checkSize);
        canvas.on('object:added', this.checkSize);
        canvas.on('object:removed', this.checkSize);
    }

    checkSize(e) {
        let store = this.store;
        store.removeWarning('low_res_warning');

        const objects = this.canvas.getObjects();
        for (const obj of objects) {
            if (obj.type === 'image') {
                if (obj.hasOwnProperty('isPDF')) {
                    continue;
                }
                let scaledWidth = obj.width * obj.scaleX;
                let scaledHeight = obj.height * obj.scaleY;

                if (obj.width < scaledWidth || obj.height < scaledHeight) {
                    store.addWarning('low_res_warning', $trans('storefront::image_editor.image_low_resolution_warning'));
                    break;
                }
            }
        }
    }
}
